import { useEffect, useState } from 'react'
import { useAuthStore } from '../../store/auth'

interface Props {
  entryId?: string
  url?: string
  mimetype: string
  name: string
}

export function AuthenticatedMedia({ entryId, url: srcUrl, mimetype, name }: Props) {
  const [blobUrl, setBlobUrl] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)
  const [failed, setFailed] = useState(false)
  const token = useAuthStore((s) => s.token)

  const fetchUrl = srcUrl ?? (entryId ? `/api/v1/entries/${encodeURIComponent(entryId)}/download` : null)

  useEffect(() => {
    if (!fetchUrl) return
    let url: string | null = null
    setLoading(true)
    setFailed(false)
    setBlobUrl(null)

    fetch(fetchUrl, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
      .then((r) => {
        if (!r.ok) throw new Error(r.statusText)
        return r.blob()
      })
      .then((blob) => {
        url = URL.createObjectURL(blob)
        setBlobUrl(url)
      })
      .catch(() => setFailed(true))
      .finally(() => setLoading(false))

    return () => {
      if (url) URL.revokeObjectURL(url)
    }
  }, [fetchUrl, token])

  if (loading) return <p style={{ opacity: 0.5, fontSize: '0.85rem', margin: '0.5rem 0' }}>loading…</p>
  if (failed || !blobUrl) return <p style={{ opacity: 0.5, fontSize: '0.85rem', margin: '0.5rem 0' }}>{name}</p>

  if (mimetype.startsWith('image/')) {
    return (
      <img
        src={blobUrl}
        alt={name}
        style={{ maxWidth: '100%', maxHeight: 480, objectFit: 'contain', display: 'block', borderRadius: 2 }}
      />
    )
  }
  if (mimetype.startsWith('video/')) {
    return (
      <video
        src={blobUrl}
        controls
        style={{ maxWidth: '100%', maxHeight: 480, display: 'block', borderRadius: 2 }}
      />
    )
  }
  if (mimetype.startsWith('audio/')) {
    return <audio src={blobUrl} controls style={{ width: '100%', marginTop: '0.25rem' }} />
  }

  return null
}
